import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress the benign "ResizeObserver loop" errors that layout-driven
// libraries (e.g. React Flow in the ERD tab) can emit. They are harmless
// timing notifications, but CRA's dev error overlay treats them as fatal
// and renders a full-screen overlay that blocks interaction.
// Primary fix: webpack devServer.client.overlay.runtimeErrors in craco.config.js
// Fallback: directly hide the overlay element if it appears
const hideResizeObserverOverlay = () => {
    const overlay = document.getElementById('webpack-dev-server-client-overlay');
    if (overlay) {
        const overlayContent = overlay.contentDocument || overlay.contentWindow?.document;
        if (overlayContent) {
            const errorText = overlayContent.body?.innerText || '';
            if (errorText.includes('ResizeObserver loop')) {
                overlay.style.display = 'none';
                console.log('[ResizeObserver] Suppressed benign error overlay');
            }
        }
    }
};

// Check periodically for the overlay (only in development)
if (process.env.NODE_ENV === 'development') {
    const checkInterval = setInterval(hideResizeObserverOverlay, 500);
    // Stop checking after 30 seconds (app should be loaded by then)
    setTimeout(() => clearInterval(checkInterval), 30000);
    
    // Also observe DOM mutations for the overlay
    const observer = new MutationObserver(hideResizeObserverOverlay);
    observer.observe(document.body, { childList: true, subtree: true });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
